// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"ba88d154","171":"57d42e18","208":"8e0708d1","238":"6c7aaf95"}[chunkId] + ".chunk.js";
};